import IOtherCompanyConstructionOutput from "../IOtherCompanyConstructionOutput";

export default (otherCompanyConstruction: IOtherCompanyConstructionOutput) => {
  const d = new FormData();
  d.append("otherCompanyConstruction[id]", otherCompanyConstruction.id);
  d.append(
    "otherCompanyConstruction[serviceTaskTypeId]",
    String(otherCompanyConstruction.serviceTaskTypeId)
  );
  d.append("otherCompanyConstruction[name]", otherCompanyConstruction.name);
  d.append(
    "otherCompanyConstruction[shortName]",
    otherCompanyConstruction.shortName
  );
  d.append(
    "otherCompanyConstruction[mConstructionId]",
    String(otherCompanyConstruction.mConstructionId)
  );

  return d;
};
